import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import _ from 'lodash'

import { createLocationTags } from '../../services/job-location'

import Layout from '../../components/layout'
import Block from '../../components/waypoint-block'
import ApplyForm from '../../components/apply-form'

const ApplicationPage = ({ data }) => {
  const { uid, prismicId, data: job } = _.get(data, [
    'allPrismicJobs',
    'edges',
    '0',
    'node',
  ])

  const locationTags = createLocationTags(job)
  return (
    <React.Fragment>
      <Helmet
        title="Versett – Careers"
        meta={[
          {
            name: 'description',
            content:
              'Versett is designed to be a place for doing meaningful work. Our team is tight-knit and dedicated to building great products.',
          },
          { name: 'keywords', content: 'versett, career, job, work' },
          { property: 'og:title', content: 'Versett – Careers' },
          {
            property: 'og:description',
            content:
              'Versett is designed to be a place for doing meaningful work. Our team is tight-knit and dedicated to building great products.',
          },
          {
            property: 'og:image',
            content: 'https://versett.com/images/social-careers.jpg',
          },
          { property: 'og:url', content: 'https://versett.com/careers/' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { property: 'og:site_name', content: 'Versett' },
          { name: 'twitter:image:alt', content: 'Careers' },
        ]}
      >
        <html lang="en" className="s-careers" />
      </Helmet>
      <Layout>
        <div className="optimal-width optimal-width--center">
          <Block>
            <section className="s-container t-section-heading--less-bottom">
              <h3>{job?.title}</h3>
              <p className="s-careers--info-tag">
                {job?.work_type ?? 'full time'} / {locationTags[0]}
                {locationTags[1] && <br />}
                {locationTags[1]} {locationTags[2] && ' / '} {locationTags[2]}
                {job?.department && <br />}
                {job?.department}
              </p>
            </section>
          </Block>
          <Block>
            <section className="s-container">
              <ApplyForm
                jobTitle={job.title}
                jobSlug={uid}
                jobId={prismicId}
                jobCountry={job.country}
                jobCity={job.city}
                formSpecification={
                  job.associated_application_form.document.data
                }
              />
            </section>
          </Block>
        </div>
      </Layout>
    </React.Fragment>
  )
}

export default ApplicationPage

export const query = graphql`
  query($uid: String) {
    allPrismicJobs(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          uid
          data {
            title
            country
            city
            work_type
            department
            associated_application_form {
              document {
                ... on PrismicJobApplicationForm {
                  data {
                    body {
                      ... on PrismicJobApplicationFormBodyFormSection {
                        primary {
                          section_title
                        }
                        items {
                          field_name
                          field_type
                          field_options {
                            raw
                          }
                          long_field_label {
                            text
                            html
                          }
                          required
                          placeholder
                          use_templating
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          prismicId
        }
      }
    }
  }
`
